/* FILE: assets/acsy-cards.js */

(function () {
  if (window.__acsyCardsInit) return;
  window.__acsyCardsInit = true;

  function parseVariants(card) {
    const el = card.querySelector('.acsy-variants-json');
    if (!el) return [];
    try { return JSON.parse(el.textContent || '[]'); } catch(e) { return []; }
  }

  function findVariant(variants, color, size) {
    const available = variants.filter(v => v && v.available);
    const match = (v, c, s) => {
      const opts = [v.option1, v.option2, v.option3].filter(Boolean);
      const okC = c ? opts.includes(c) : true;
      const okS = s ? opts.includes(s) : true;
      return okC && okS;
    };

    let v = available.find(v => match(v, color, size));
    if (v) return v;

    if (color && !size) {
      v = available.find(v => match(v, color, null));
      if (v) return v;
    }

    if (size && !color) {
      v = available.find(v => match(v, null, size));
      if (v) return v;
    }

    return available[0] || variants[0] || null;
  }

  function setSwatchColorFromName(btn, name) {
    const n = (name || '').toLowerCase().trim();

    const map = {
      'black': '#000000',
      'white': '#ffffff',
      'red': '#d32f2f',
      'blue': '#1976d2',
      'navy': '#0b1f3a',
      'grey': '#9e9e9e',
      'gray': '#9e9e9e',
      'beige': '#d7c4a3',
      'brown': '#6d4c41',
      'green': '#2e7d32',
      'pink': '#ec407a',
      'purple': '#7e57c2',
      'yellow': '#fbc02d',
      'orange': '#fb8c00'
    };

    btn.style.background = map[n] || '#ddd';
  }

  function initCard(card) {
    const url = card.getAttribute('data-url');
    const variants = parseVariants(card);

    const primaryImg = card.querySelector('[data-primary]');
    const secondaryImg = card.querySelector('[data-secondary]');
    const infoLink = card.querySelector('.acsy-card__infoLink');

    const sizeBtns = card.querySelectorAll('.acsy-size');
    const swatches = card.querySelectorAll('.acsy-swatch');

    let selectedSize = null;
    let selectedColor = null;

    swatches.forEach(s => setSwatchColorFromName(s, s.getAttribute('data-color')));

    function applySelection() {
      const v = findVariant(variants, selectedColor, selectedSize);
      if (!v) {
        if (infoLink) infoLink.href = url;
        return;
      }
      if (infoLink) infoLink.href = url + '?variant=' + v.id;

      if (primaryImg && v.featured_image && v.featured_image.src) {
        if (secondaryImg) secondaryImg.style.opacity = '0';
        primaryImg.src = v.featured_image.src;
      }
    }

    function restoreHover() {
      if (secondaryImg) secondaryImg.style.opacity = '';
    }

    sizeBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (btn.getAttribute('data-available') !== 'true') return;

        selectedSize = btn.getAttribute('data-size');

        sizeBtns.forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        applySelection();
      });
    });

    swatches.forEach(btn => {
      btn.addEventListener('mouseenter', () => {
        if (btn.getAttribute('data-available') !== 'true') return;
        const previewColor = btn.getAttribute('data-color');
        const v = findVariant(variants, previewColor, selectedSize);
        if (v && primaryImg && v.featured_image && v.featured_image.src) {
          if (secondaryImg) secondaryImg.style.opacity = '0';
          primaryImg.src = v.featured_image.src;
        }
      });

      btn.addEventListener('mouseleave', () => {
        restoreHover();
        applySelection();
      });

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (btn.getAttribute('data-available') !== 'true') return;

        selectedColor = btn.getAttribute('data-color');

        swatches.forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        const v = findVariant(variants, selectedColor, selectedSize);
        if (v) window.location.href = url + '?variant=' + v.id;
        else window.location.href = url;
      });
    });

    if (infoLink) {
      infoLink.addEventListener('click', (e) => {
        const inHover = e.target.closest('.acsy-card__infoHover');
        if (!inHover) return;
        e.preventDefault();
        e.stopPropagation();
        const v = findVariant(variants, selectedColor, selectedSize);
        window.location.href = v ? (url + '?variant=' + v.id) : url;
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('.acsy-card').forEach(initCard);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
